import { useState } from "react";
import { useDispatch } from "react-redux";
import { setGoalRename } from "../../redux/actions";
import styled from "styled-components";
import Backdrop from "../Backdrop";
import theme from "../../theme/theme";

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .modalBody {
    height: 30%;
    width: 60%;
    margin: 5em auto;
    background-color: white;
    padding: 3em;
    border-radius: 15px;
    text-align: left;

    @media (max-width: 480px) {
      padding: 1.5em;
      width: 80%;
      height: 20%;
    }
  }

  .headerCardContainer {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};
    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  & form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    & input {
      border-bottom: 2px solid #69c7dd;
      padding: 10px 20px;
      border-radius: 0px;
      margin-bottom: 10px;
    }

    & button {
      display: block;
      width: 100%;
      color: white;
      font-size: 15px;
      font-weight: 700;
      padding: 15px 0px;
      border: none;
      background: #6ac7dd;
      border-radius: 4px;
      cursor: pointer;
    }

    & p {
      display: ${(props) => (props.isInvalid ? "block" : "none")};
      font-size: 12px;
      color: red;
      margin: 0px;
    }
  }
`;

const EditgoalIdModalScreen = ({ id, isHidden, actualName }) => {
  const dispatch = useDispatch();
  const initialValue = {
    goalTitle: actualName,
  };
  const blankFields = {
    goalTitle: "",
  };
  const [formData, setFormData] = useState(initialValue);
  const [isInvalid, setIsIvalid] = useState(false);

  const submitForm = (event) => {
    event.preventDefault();
    if (formData.goalTitle === "") {
      setIsIvalid(true);
    } else {
      dispatch(
        setGoalRename({
          goalId: id,
          goalTitle: formData.goalTitle,
        })
      );
      setFormData(blankFields);
      isHidden(false);
    }
  };
  const onChange = (event) => {
    setIsIvalid(false);
    setFormData({ ...formData, [event.target.id]: event.target.value });
  };

  return (
    <Backdrop>
      <Wrapper isInvalid={isInvalid}>
        <div className="modalBody">
          <form autoComplete="off" onSubmit={submitForm}>
            <div className="headerCardContainer">
              <label htmlFor="goalTitle">New goal title</label>
              <div
                onClick={() => {
                  isHidden(false);
                }}
                style={{
                  float: "right",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                X
              </div>
            </div>
            <input
              type="text"
              id="goalTitle"
              onChange={onChange}
              value={formData.goalTitle}
            />
            <div>
              <p>Please enter a valid name</p>
              <button type="submit">Save</button>
            </div>
          </form>
        </div>
      </Wrapper>
    </Backdrop>
  );
};

export default EditgoalIdModalScreen;
